import { DEFAULT_URL } from '../../pages/DiscoverPage/const';

export const LOGGED_IN_ITEMS: ExpandedNavigationItem[] = [
  {
    title: 'home',
    url: '/home',
    className: 'home-link',
  },
  {
    title: 'discover',
    url: DEFAULT_URL,
    subItems: [
      {
        title: 'videos',
        description: 'videosDescription',
        url: `${DEFAULT_URL}/videos`,
      },
      {
        title: 'text',
        description: 'textDescription',
        url: `${DEFAULT_URL}/insights`,
      },
      {
        title: 'pathways',
        description: 'pathwaysDescription',
        url: `${DEFAULT_URL}/pathways`,
      },
      {
        title: 'experts',
        description: 'expertsDescriprion',
        url: `${DEFAULT_URL}/experts`,
      },
    ],
  },
  {
    title: 'pathways',
    url: '/pathways',
    className: 'pathways-link',
  },
  {
    title: 'analytics',
    url: '/analytics',
    managerUrl: '/analytics/dashboard',
  },
];

export const PROFILE_LINKS = [
  {
    title: 'header.myAccount',
    url: '/my-account/',
  },
  {
    title: 'header.myMembership',
    url: '/my-account/membership-area/',
  },
  {
    title: 'header.myWatchlist',
    url: '/home/#my-watchlist',
  },
];

type SubNavigationItem = {
  title: string;
  description: string;
  url: string;
};

export type ExpandedNavigationItem = {
  title: string;
  url: string;
  subItems?: SubNavigationItem[];
  className?: string;
  managerUrl?: string;
};
